const SERVICE_KEY = process.env.REACT_APP_SERVICE_KEY;
export const API_URL = `/getRecreationalForestInfo?serviceKey=${SERVICE_KEY}`;
